'use client'

import * as React from 'react'

// vaul traps focus inside its content, so floating content portaled to <body> can't hold focus.
// Kept apart from drawer.tsx so dialogs and popups don't pull in vaul.
const DrawerPortalContainerContext =
  React.createContext<null | React.RefObject<HTMLDivElement | null>>(null)

function DrawerPortalContainerBoundary({ children }: { children: React.ReactNode }) {
  return (
    <DrawerPortalContainerContext.Provider value={null} data-sentry-element="DrawerPortalContainerContext.Provider" data-sentry-component="DrawerPortalContainerBoundary" data-sentry-source-file="drawer-portal-context.tsx">
      {children}
    </DrawerPortalContainerContext.Provider>
  )
}

function useDrawerPortalContainer() {
  return React.useContext(DrawerPortalContainerContext) ?? undefined
}

export { DrawerPortalContainerBoundary, DrawerPortalContainerContext, useDrawerPortalContainer }
